import Vue from 'vue';
import Router from 'vue-router';
import CONFIG from './config';
import Initial from './views/Initial.vue';
import Rules from './views/Rules.vue';

Vue.use(Router);

const routes = [
  {
    path: '/',
    name: 'initial',
    component: Initial
  },
  {
    path: '/mask',
    name: 'mask',
    component: () => import('./views/MaskCreator.vue'),
    meta: {
      date: CONFIG.settings.dates.contest.endDate
    }
  },
  {
    path: '/rules',
    name: 'rules',
    component: Rules
  },
  {
    path: '*',
    redirect: '/'
  }
];

const router = new Router({
  routes
});

router.beforeEach((to, from, next) => {

  if (to.matched.some(record => record.meta.date)) {
    const currentDate = CONFIG.settings.date !== null ? new Date(CONFIG.settings.date) : new Date();

    if (currentDate.getTime() >= to.meta.date.getTime()) {
      next('/');
      return;
    } else {
      next();
      return;
    }
  }

  next();
  return;
})

export default router;
